@use 'styles/variables';
@use 'styles/mixins';

.Overlay {
  @include mixins.fixed-top-left;
  z-index: variables.$ZOverModalContent;

  max-height: 80vh;
  overflow-y: auto;

  background-color: rgba(variables.$black-secondary, 0.2);

  @include mixins.flex-centered;
  @include mixins.fullscreen;
}

.WithBiggestZIndex {
  z-index: variables.$ZOverBlockly;
}

.Wrap {
  position: relative;

  max-height: 80vh;

  &_Close {
    position: absolute;
    top: 1.6rem;
    right: 1.6rem;

    &_Outside {
      top: -10%;
      right: -10%;
    }

    &_Fixed {
      position: fixed;
    }

    &_Btn,
    &_MultipleBtn {
      display: flex;

      padding: 0.8rem;

      border-radius: 5px;
    }
  }

  &_StretchedCloseButton {
    position: absolute;
    top: 1.6rem;
    right: 1.6rem;
    left: 140%;
    z-index: 1;
  }
}

.Modal {
  @include mixins.flex-column;

  padding: 5.6rem;
  border: 1px solid variables.$grey6;

  border-radius: 5px;

  background-color: variables.$white;

  &_WithoutPadding {
    padding: 0;
  }

  &_WithoutRoundedBorders {
    border-radius: 0;
  }

  &_WithMinWidth {
    min-width: 50vw;
  }

  &_BottomMargin {
    margin-bottom: 3rem;
  }

  &_Labels {
    @include mixins.flex-align-center;
    margin-bottom: 2.8rem;

    &_Left {
      text-align: left;
    }

    &_Right {
      margin-left: auto;

      > *:not(:first-child) {
        margin-left: 1.6rem;
      }
    }
  }

  &_Description {
    @include mixins.flex-align-center;

    width: 100%;
    margin-bottom: 5.6rem;

    text-align: left;

    & > svg {
      margin-right: 0.8rem;
    }

    &_HalfMargin {
      margin-bottom: 2.8rem;
    }
  }
}

@include mixins.forScreen(
  variables.$mobile-small-width,
  variables.$desktop-width
) {
  .Modal {
    align-items: center;
    max-width: 80vw;

    border: initial;

    &:not(.Modal_WithoutPadding) {
      padding: 3.5rem;
    }

    & > div {
      width: 100%;
    }

    &_Labels {
      margin-bottom: 2.4rem;

      &_Left {
        display: flex;
        justify-content: center;

        font-size: 2rem;

        span {
          text-align: center;
        }
      }
    }

    &_Description {
      span {
        font-size: 1.4rem;
        text-align: center;
      }
    }
  }
}

@include mixins.forScreen(
  variables.$mobile-small-width,
  variables.$mobile-big-width - 1
) {
  .Modal {
    &_Labels {
      margin-bottom: 3rem;
    }
  }

  .Wrap {
    &_Close {
      &_Outside {
        right: 0;
      }
    }
  }
}
